import type { WorkOrderNavData } from 'gql/graphql';
import { formatDateToLocale } from 'utils';

interface IGetLabelWorkOrder extends Pick<WorkOrderNavData, 'workOrderChange'> {
    internalNumber?: string | null;
    signingDate?: string;
}

export const getLabelWorkOrder = (order: IGetLabelWorkOrder | undefined, noEntityTitle = false) => {
    if (order?.workOrderChange) {
        const { signingDate: orderChangeSigningDate } = order?.workOrderChange || {};

        return `${noEntityTitle ? '' : 'Наряд-Заказ '}${order?.internalNumber ? `№${order?.internalNumber}` : ''} 
        ${orderChangeSigningDate ? `от ${formatDateToLocale(orderChangeSigningDate)}` : ''}`;
    }

    return `${noEntityTitle ? '' : 'Наряд-Заказ '}${order?.internalNumber ? `№${order?.internalNumber}` : ''} ${
        order?.signingDate ? `от ${formatDateToLocale(order.signingDate)}` : ''
    }`;
};

export const getLabelWorkOrderNoSingingDate = (order: Pick<IGetLabelWorkOrder, 'internalNumber'> | undefined) =>
    `Наряд-Заказ ${order?.internalNumber ? `№${order?.internalNumber}` : ''}`;
